'use es6';

import Forms from '../models/Forms';
import { RECEIVED_FORMS, REQUESTED_FORMS_FAILED, REQUESTED_FORMS } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new Forms(), action) => {
  switch (action.type) {
    case REQUESTED_FORMS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_FORMS:
      return action.payload.forms;
    case REQUESTED_FORMS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});